import Emitter from "./Emitter";

export default class BalanceChange extends Emitter {
    constructor(gb) {
        super(gb);
    }

    SPINGAMES_handler(data) {
        if (data && typeof data !== "object") {
            this.emitTop({ event: "round_result", balance: data });
            this.emitParent({ event: "round_result", balance: data });
        }
    }

    EXCITE_handler(balance) {
        this.emitParent({ event: "setBalance", payload: { balance: balance }});
    }

    PLAYTECH_handler(balance) {
        if (this.gb.ptResFeat && this.gb.ptResFeat.includes('balanceupdate')) {
            let obj = {
                _type: "ucip.balanceupdate.g2wBalanceUpdateNotification",
                balance: {
                    value: typeof balance === "number" ? balance/100 : balance,
                    winAmount: 0,
                }
            }
            this.emitParent(JSON.stringify(obj));
        }
    }

    _default(balance) {
        this.emitTop({ wpgaction: "balance", param: { balance: balance } });
        this.emitParent({ wpgaction: "balance.parent", param: { balance: balance } });
    }
}
